(function(){
var R=document.getElementById('osc-root');if(!R||window.__osc)return;window.__osc=1;
document.body.appendChild(R);
var ov=R.querySelector('.osc-ov'),dw=R.querySelector('.osc');
var elN=R.querySelector('.osc-n'),elI=R.querySelector('.osc-items'),elT=R.querySelector('.osc-tot'),elC=R.querySelector('.osc-ctat');
var elB=R.querySelector('.osc-bundle'),elU=R.querySelector('.osc-upsblock'),elTr=R.querySelector('.osc-track'),elD=R.querySelector('.osc-dots');
var elRev=R.querySelector('.osc-rev'),elSv=R.querySelector('.osc-svc'),elF=R.querySelector('.osc-ft'),nc=R.querySelector('.osc-nc');
var elAcc=R.querySelector('.osc-acc'),CANAP=false;
try{CANAP=!!(window.ApplePaySession&&ApplePaySession.canMakePayments())}catch(e){}
if(elAcc&&!CANAP)elAcc.hidden=true; // Apple Pay uniquement : rien sur les autres appareils
var SVC=R.getAttribute('data-svc')||'';
var TX={empty:R.getAttribute('data-t-empty')||'Votre panier est vide.',shop:R.getAttribute('data-t-shop')||'Voir la sélection',shopurl:R.getAttribute('data-t-shopurl')||'/collections/all',size:R.getAttribute('data-t-size')||'Taille',add:R.getAttribute('data-t-add')||'Ajouter',added:R.getAttribute('data-t-added')||'✓ Ajouté'};
var UDUR=(parseFloat(R.getAttribute('data-updur'))||5)*1000;
var RDUR=(parseFloat(R.getAttribute('data-revdur'))||4.5)*1000;
var CUR='EUR',LOC=(document.documentElement.lang||'fr'),CART=null,BUSY=0,SVCBUSY=0;

function money(c){try{return new Intl.NumberFormat(LOC,{style:'currency',currency:CUR}).format(c/100)}catch(e){return (c/100).toFixed(2).replace('.',',')+' €'}}
function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML}
function thumb(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||200)}
function api(u,o){return fetch(u,o).then(function(r){return r.json()})}
function post(u,b){return api(u,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify(b)})}
function pull(){return api('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'}).then(function(c){CART=c;CUR=c.currency||CUR;draw();return c})}
function show(){R.hidden=false;void dw.offsetWidth;ov.classList.add('on');dw.classList.add('on');document.documentElement.style.overflow='hidden'}
function hide(){ov.classList.remove('on');dw.classList.remove('on');document.documentElement.style.overflow='';setTimeout(function(){R.hidden=true},330)}
function openCart(){pull();show()}
function isSvc(it){return SVC&&String(it.variant_id)===SVC}

function draw(){
  if(!CART)return;
  var goods=CART.items.filter(function(it){return !isSvc(it)});
  var svc=CART.items.filter(isSvc)[0];
  var n=goods.reduce(function(a,it){return a+it.quantity},0);
  elN.textContent=n?'· '+n:'';
  elT.textContent=money(CART.total_price||0);
  drawPromo();
  if(elC)elC.textContent='· '+money(CART.total_price||0);
  if(!n){
    elI.innerHTML='<div class="osc-mt"><p>'+esc(TX.empty)+'</p><a class="osc-cta" href="'+esc(TX.shopurl)+'">'+esc(TX.shop)+'</a></div>';
    if(elB)elB.hidden=true;elU.hidden=true;elF.style.display='none';return;
  }
  elF.style.display='';
  if(elB)elB.hidden=false;
  elI.innerHTML=goods.map(function(it){
    var opt=(it.options_with_values||[]).map(function(o){return o.value}).filter(function(v){return v&&v!=='Default Title'}).join(' · ');
    var cmp=(it.original_price>it.final_price)?'<s>'+money(it.original_price)+'</s>':'';
    return '<div class="osc-it" data-k="'+esc(it.key)+'">'
      +'<div class="osc-th" style="background-image:url(\''+esc(thumb(it.image,180))+'\')"></div>'
      +'<div class="osc-itc"><p class="osc-itt">'+esc(it.product_title)+'</p>'
      +(opt?'<p class="osc-itv">'+esc(opt)+'</p>':'')
      +'<div class="osc-itr"><p class="osc-itp">'+cmp+money(it.final_price)+'</p>'
      +'<div class="osc-qty"><button type="button" data-d="-1" aria-label="Moins">−</button><span>'+it.quantity+'</span><button type="button" data-d="1" aria-label="Plus">+</button></div>'
      +'</div></div>'
      +'<button class="osc-rm" type="button" aria-label="Retirer"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg></button></div>';
  }).join('');
  if(elSv){
    if(svc){elSv.hidden=false;elSv.innerHTML='<span>'+esc(svc.product_title)+'</span><span>'+money(svc.final_line_price)+'</span>'}
    else{elSv.hidden=true}
  }
  if(nc&&!SVCBUSY)nc.checked=!!svc;
  var inCart={};CART.items.forEach(function(i){inCart[i.variant_id]=1});
  SHOWN=UPS.filter(function(u){return !u.vars.some(function(v){return inCart[v.id]})});
  if(SHOWN.length){
    elU.hidden=false;
    elTr.innerHTML=SHOWN.map(function(u){
      var pick=u.vars.length>1?'<select class="osc-usel" aria-label="'+esc(TX.size)+'">'+u.vars.map(function(v){return '<option value="'+esc(v.id)+'">'+esc(v.t)+'</option>'}).join('')+'</select>':'';
      return '<div class="osc-u"><div class="osc-uth" style="background-image:url(\''+esc(u.img)+'\')"></div><div class="osc-ut"><p>'+esc(u.t)+'</p><span>'+money(u.p)+'</span>'+pick+'</div><button class="osc-ua" type="button" data-v="'+esc(u.vars[0].id)+'">'+esc(TX.add)+'</button></div>';
    }).join('');
    elD.innerHTML=SHOWN.map(function(_,i){return '<i data-i="'+i+'"></i>'}).join('');
    if(UI>=SHOWN.length)UI=0;
    slideTo(UI,true);
  }else{elU.hidden=true}
}

var UPS=[].slice.call(document.querySelectorAll('#osc-src i')).map(function(e){
  var vars=[].slice.call(e.querySelectorAll('b')).map(function(b){return {id:b.getAttribute('data-vid'),t:b.textContent}});
  if(!vars.length)vars=[{id:e.getAttribute('data-v'),t:''}];
  return {t:e.getAttribute('data-t'),p:parseInt(e.getAttribute('data-p'),10)||0,img:e.getAttribute('data-img'),vars:vars};
});
var SHOWN=[],UI=0,utimer=null,dragging=false,x0=0,dx=0;

function slideTo(k,instant){
  if(!SHOWN.length)return;
  UI=(k+SHOWN.length)%SHOWN.length;
  elTr.style.transition=instant?'none':'';
  elTr.style.transform='translateX('+(-UI*100)+'%)';
  if(instant)void elTr.offsetWidth,elTr.style.transition='';
  [].slice.call(elD.children).forEach(function(d,i){d.classList.toggle('on',i===UI)});
}
function autoU(){clearInterval(utimer);utimer=setInterval(function(){if(!R.hidden&&SHOWN.length>1&&!dragging)slideTo(UI+1)},UDUR)}
elTr.addEventListener('pointerdown',function(e){if(e.target.closest('.osc-ua,.osc-usel'))return;dragging=true;x0=e.clientX;dx=0;elTr.style.transition='none';elTr.setPointerCapture(e.pointerId)});
elTr.addEventListener('pointermove',function(e){if(!dragging)return;dx=e.clientX-x0;elTr.style.transform='translateX(calc('+(-UI*100)+'% + '+dx+'px))'},{passive:true});
function endDrag(){if(!dragging)return;dragging=false;elTr.style.transition='';var w=elTr.offsetWidth||1;if(Math.abs(dx)>w*0.18)slideTo(UI+(dx<0?1:-1));else slideTo(UI);dx=0}
elTr.addEventListener('pointerup',endDrag);elTr.addEventListener('pointercancel',endDrag);
elD.addEventListener('click',function(e){var d=e.target.closest('i[data-i]');if(d)slideTo(parseInt(d.getAttribute('data-i'),10))});

var RS=[].slice.call(elRev?elRev.querySelectorAll('.osc-rs'):[]),RI=0,rtimer=null;
function goRev(k){if(!RS.length)return;RI=(k+RS.length)%RS.length;RS.forEach(function(s,i){s.classList.toggle('on',i===RI)})}
if(RS.length){goRev(0);rtimer=setInterval(function(){if(!R.hidden)goRev(RI+1)},RDUR)}

function chg(k,q){if(BUSY)return Promise.resolve();BUSY=1;
  return post('/cart/change.js',{id:k,quantity:q}).then(function(c){CART=c;draw()}).catch(function(){}).then(function(){BUSY=0})}
function add(id,q){return post('/cart/add.js',{items:[{id:id,quantity:q||1}]}).then(pull)}

R.addEventListener('click',function(e){
  var t=e.target;
  if(t.classList.contains('osc-ov')||t.closest('.osc-x')){hide();return}
  var q=t.closest('.osc-qty button');
  if(q){var it=q.closest('.osc-it');var cur=parseInt(it.querySelector('.osc-qty span').textContent,10)||1;chg(it.getAttribute('data-k'),cur+parseInt(q.getAttribute('data-d'),10));return}
  var rm=t.closest('.osc-rm');
  if(rm){chg(rm.closest('.osc-it').getAttribute('data-k'),0);return}
  var ua=t.closest('.osc-ua');
  if(ua){var row=ua.closest('.osc-u'),sel=row?row.querySelector('.osc-usel'):null;
    ua.setAttribute('data-ok','1');ua.textContent=TX.added;
    add(sel?sel.value:ua.getAttribute('data-v'),1);return}
});

if(nc){
  nc.addEventListener('change',function(){
    if(!SVC||SVCBUSY){nc.checked=!nc.checked;return}
    SVCBUSY=1;nc.disabled=true;
    var want=nc.checked;
    var line=(CART&&CART.items||[]).filter(isSvc)[0];
    var op=want?(line?Promise.resolve():post('/cart/add.js',{items:[{id:SVC,quantity:1}]}))
               :(line?post('/cart/change.js',{id:line.key,quantity:0}):Promise.resolve());
    op.catch(function(){}).then(function(){SVCBUSY=0;return pull()})
      .then(function(){nc.disabled=false}).catch(function(){SVCBUSY=0;nc.disabled=false;pull()});
  });
}
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!R.hidden)hide()});

window.addEventListener('click',function(e){
  if(!e.target.closest||e.target.closest('#osc-root'))return;
  var a=e.target.closest('a[href],[data-panel="cart"],[aria-controls="cart"]');if(!a)return;
  var h=(a.getAttribute('href')||'').replace(/^https?:\/\/[^\/]+/i,'');
  if(a.getAttribute('data-panel')==='cart'||a.getAttribute('aria-controls')==='cart'||/^\/(([a-z]{2}(-[a-z]{2})?)\/)?cart\/?(\?|#|$)/i.test(h)){e.preventDefault();e.stopImmediatePropagation();openCart()}
},true);

/* garde-fou (2026-10-17) : si le tiroir d'origine du thème (aside#cart) s'ouvre par un autre chemin,
   on le referme aussitôt et on ouvre le panier On Sky à la place. */
(function(){
  var A=document.getElementById('cart');if(!A||!window.MutationObserver)return;
  var H=document.documentElement;
  function steal(){
    if(!A.classList.contains('toggle')&&A.getAttribute('aria-hidden')!=='false')return; // seul le tiroir panier nous intéresse
    A.classList.remove('toggle');A.setAttribute('aria-hidden','true');
    if(!H.querySelector('.m6pn.toggle'))H.classList.remove('m6pn-open'); // pas d'autre panneau ouvert : on retire le voile
    if(R.hidden)openCart();
  }
  new MutationObserver(steal).observe(A,{attributes:true,attributeFilter:['class','aria-hidden']});
})();

document.addEventListener('submit',function(e){
  var f=e.target;if(!f||!f.action||f.action.indexOf('/cart/add')<0)return;
  e.preventDefault();e.stopImmediatePropagation();
  var btn=f.querySelector('[type=submit]');if(btn)btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{Accept:'application/json'},credentials:'same-origin'})
    .then(function(r){return r.json()}).then(function(){return pull()}).then(show)
    .catch(function(){f.submit()})
    .then(function(){if(btn)btn.disabled=false});
},true);

/* ---- codes promo : champ en bas du panier + bouton Halloween (2026-10-14) ---- */
var elPin=R.querySelector('.osc-pin'),elPb=R.querySelector('.osc-pbtn'),elPm=R.querySelector('.osc-pmsg'),elPc=R.querySelector('.osc-pcodes'),elDs=R.querySelector('.osc-disc'),elHw=R.querySelector('.osc-hw'),elHb=R.querySelector('.osc-hw-b');
var PT={ok:R.getAttribute('data-t-pok')||'Appliqué ✓',ap:R.getAttribute('data-t-pap')||'Appliquer',bad:R.getAttribute('data-t-pbad')||'Code non valable.',rm:R.getAttribute('data-t-prm')||'Retirer'},PBUSY=0;
function codesOn(){return ((CART&&CART.discount_codes)||[]).filter(function(d){return d.applicable}).map(function(d){return d.code})}
function drawPromo(){
  if(!CART)return;
  var on=codesOn();
  var pb=R.querySelector('.osc-promo');if(pb)pb.style.display=(CART.item_count>0)?'':'none';
  if(pb&&on.length&&'open' in pb)pb.open=true; // un code est actif : on montre sa pastille (avec la croix pour le retirer)
  if(elPc)elPc.innerHTML=on.map(function(c){return '<span class="osc-pc">'+esc(c)+'<button type="button" data-rmc="'+esc(c)+'" aria-label="'+esc(PT.rm)+' '+esc(c)+'">×</button></span>'}).join('');
  if(elDs){var d=CART.total_discount||0;elDs.hidden=!(d>0);if(d>0)elDs.querySelector('b').textContent='−'+money(d)}
  if(elHb){var hc=(elHb.getAttribute('data-code')||'').toUpperCase(),has=on.some(function(c){return c.toUpperCase()===hc});
    if(has){elHb.setAttribute('data-on','');elHb.textContent=PT.ok}else{elHb.removeAttribute('data-on');elHb.textContent=PT.ap}}
}
function setCodes(list){return post('/cart/update.js',{discount:list.join(',')}).then(function(c){CART=c;draw();return c})}
function applyCode(code){
  code=(code||'').trim().toUpperCase();if(!code||PBUSY)return;
  if(codesOn().some(function(c){return c.toUpperCase()===code})){if(elPin)elPin.value='';return}
  PBUSY=1;if(elPb)elPb.disabled=true;if(elPm)elPm.hidden=true;
  var keep=codesOn();
  setCodes(keep.concat([code])).then(function(c){
    var ok=(c.discount_codes||[]).some(function(d){return d.applicable&&d.code.toUpperCase()===code});
    if(ok){if(elPin)elPin.value='';return}
    if(elPm){elPm.textContent=PT.bad;elPm.hidden=false}
    return setCodes(keep);
  }).catch(function(){if(elPm){elPm.textContent=PT.bad;elPm.hidden=false}})
  .then(function(){PBUSY=0;if(elPb)elPb.disabled=false});
}
function removeCode(code){if(PBUSY)return;PBUSY=1;setCodes(codesOn().filter(function(c){return c!==code})).catch(function(){}).then(function(){PBUSY=0})}
if(elPb)elPb.addEventListener('click',function(){applyCode(elPin.value)});
if(elPin)elPin.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();applyCode(elPin.value)}});
R.addEventListener('click',function(e){
  var x=e.target.closest('[data-rmc]');if(x){removeCode(x.getAttribute('data-rmc'));return}
  var h=e.target.closest('.osc-hw-b');if(h&&!h.hasAttribute('data-on'))applyCode(h.getAttribute('data-code'));
});
if(elHw){var hwEnd=new Date(elHw.getAttribute('data-end')).getTime();if(!isNaN(hwEnd)&&Date.now()>hwEnd)elHw.hidden=true}

/* ---- favoris (façon wedunk) : cœur dans le header, onglet Favoris dans le tiroir, cœurs [data-osky-fav] sur les pages (2026-10-14) ---- */
var FK='osky_fav',elTabs=R.querySelectorAll('.osc-tab'),elFp=R.querySelector('.osc-favp'),elFl=R.querySelector('.osc-fl'),elFn=R.querySelector('.osc-fn'),elBd=R.querySelector('.osc-bd'),TAB='cart';
var FT={empty:R.getAttribute('data-t-fempty')||'Aucun favori pour le moment.',add:TX.add,rm:R.getAttribute('data-t-prm')||'Retirer',size:TX.size,fadd:R.getAttribute('data-t-fadd')||'Ajouter aux favoris',frm:R.getAttribute('data-t-frm')||'Retirer des favoris'};
var ROOT=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/');
function favGet(){try{var a=JSON.parse(localStorage.getItem(FK));return Array.isArray(a)?a:[]}catch(e){return []}}
function favSet(a){try{localStorage.setItem(FK,JSON.stringify(a))}catch(e){}favSync()}
function favHas(h){return favGet().indexOf(h)>-1}
function favToggle(h){var a=favGet(),i=a.indexOf(h);if(i>-1)a.splice(i,1);else a.unshift(h);favSet(a);return i<0}
var hdrFav=document.querySelector('li.wishlist-header');
if(hdrFav){hdrFav.classList.remove('hidden');var hb=document.createElement('span');hb.className='osky-fbub';hdrFav.querySelector('a').appendChild(hb)}
function favSync(){
  var n=favGet().length;
  if(elFn)elFn.textContent=n?'· '+n:'';
  var bub=document.querySelector('.osky-fbub');if(bub){bub.textContent=n;bub.style.display=n?'':'none'}
  [].forEach.call(document.querySelectorAll('[data-osky-fav]'),function(b){var on=favHas(b.getAttribute('data-osky-fav'));b.classList.toggle('is-fav',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',on?FT.frm:FT.fadd)});
  if(TAB==='fav')favDraw();
}
function favDraw(){
  var a=favGet();
  if(!a.length){elFl.innerHTML='<div class="osc-fe"><span>♡</span><p>'+esc(FT.empty)+'</p></div>';return}
  Promise.all(a.map(function(h){return fetch(ROOT+'products/'+encodeURIComponent(h)+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null}).catch(function(){return null})})).then(function(ps){
    elFl.innerHTML=ps.map(function(p,i){
      if(!p)return '';
      var vs=(p.variants||[]).filter(function(v){return v.available});
      var img=p.featured_image?thumb((p.featured_image.indexOf('//')===0?'https:':'')+p.featured_image,180):'';
      var cmp=p.compare_at_price>p.price?'<s>'+money(p.compare_at_price)+'</s>':'';
      var pick=vs.length>1?'<select class="osc-fsel" aria-label="'+esc(FT.size)+'">'+vs.map(function(v){return '<option value="'+v.id+'">'+esc(v.title)+'</option>'}).join('')+'</select>':'';
      return '<div class="osc-fi" data-h="'+esc(a[i])+'"><a class="osc-th" href="'+esc(ROOT+'products/'+a[i])+'" style="background-image:url(\''+esc(img)+'\')"></a>'
        +'<div class="osc-itc"><a class="osc-itt" href="'+esc(ROOT+'products/'+a[i])+'">'+esc(p.title)+'</a><p class="osc-fp">'+cmp+'<b>'+money(p.price)+'</b></p>'+pick+'</div>'
        +'<div class="osc-fa">'+(vs.length?'<button type="button" class="osc-fadd" data-v="'+(vs[0]?vs[0].id:'')+'">'+esc(FT.add)+'</button>':'')+'<button type="button" class="osc-frm">'+esc(FT.rm)+'</button></div></div>';
    }).join('');
  });
}
function setTab(t){TAB=t;dw.setAttribute('data-tab',t);[].forEach.call(elTabs,function(b){b.classList.toggle('on',b.getAttribute('data-tab')===t)});if(t==='fav')favDraw()}
var FAVOPEN=0,_show=show;
show=function(){if(!FAVOPEN)setTab('cart');FAVOPEN=0;_show()};
function openFav(){FAVOPEN=1;setTab('fav');pull();show()}
R.addEventListener('click',function(e){
  var tb=e.target.closest('.osc-tab');if(tb){setTab(tb.getAttribute('data-tab'));return}
  var fa=e.target.closest('.osc-fadd');if(fa){var row=fa.closest('.osc-fi'),sl=row.querySelector('.osc-fsel');fa.disabled=true;add(sl?sl.value:fa.getAttribute('data-v'),1).then(function(){setTab('cart')});return}
  var fr=e.target.closest('.osc-frm');if(fr){favToggle(fr.closest('.osc-fi').getAttribute('data-h'));return}
});
/* Le thème déplace la cible entre l'appui et le relâché : on mémorise l'appui sur le cœur et on agit au clic (fenêtre, en premier). */
var FPD=null;
function favHit(e){return e.target&&e.target.closest?e.target.closest('[data-osky-fav]'):null}
['pointerdown','touchstart','mousedown'].forEach(function(t){window.addEventListener(t,function(e){var b=favHit(e);if(b){var p=e.touches?e.touches[0]:e;FPD={b:b,x:p.clientX,y:p.clientY,t:Date.now()};e.stopPropagation()}},{capture:true,passive:true})});
window.addEventListener('click',function(e){
  var w=e.target&&e.target.closest?e.target.closest('a[href="#wishlist"]'):null;
  if(w){e.preventDefault();e.stopImmediatePropagation();openFav();return}
  var b=favHit(e);
  if(!b&&FPD&&Date.now()-FPD.t<900&&Math.abs(e.clientX-FPD.x)<14&&Math.abs(e.clientY-FPD.y)<14)b=FPD.b;
  FPD=null;
  if(!b)return;
  e.preventDefault();e.stopImmediatePropagation();
  favToggle(b.getAttribute('data-osky-fav'));b.classList.remove('pop');void b.offsetWidth;b.classList.add('pop');
},true);
document.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.matches&&e.target.matches('[data-osky-fav]')){e.preventDefault();e.target.click()}});
window.addEventListener('storage',function(e){if(e.key===FK)favSync()});
favSync();

/* haut du panier (2026-10-17) : compte à rebours Halloween (ne tourne que panier ouvert, se masque seul à la fin)
   + au toucher du code : copié, et pré-rempli dans le champ code promo. Rien n'est appliqué sans le bouton « Appliquer ».
   (Depuis le 17/10 la carte n'affiche plus le code : la partie « copie » attend, inactive, qu'on remette le bouton .osc-hwc-code.) */
(function(){
  var card=R.querySelector('.osc-hwc'),cd=R.querySelector('.osc-cd');if(!card||!cd)return;
  var end=new Date(card.getAttribute('data-end')).getTime(),u=card.getAttribute('data-u')||'j',timer=0;
  function p(n){return (n<10?'0':'')+n}
  function tick(){
    var s=Math.floor((end-Date.now())/1000);
    if(isNaN(s)||s<=0){card.hidden=true;clearInterval(timer);return}
    var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60);
    cd.textContent=(d?d+u+' ':'')+p(h)+':'+p(m)+':'+p(s%60);
  }
  tick();timer=setInterval(function(){if(!R.hidden)tick()},1000);
  var btn=card.querySelector('.osc-hwc-code');if(!btn)return;
  var keep=btn.innerHTML,back=0;
  btn.addEventListener('click',function(){
    var code=btn.getAttribute('data-code'),pr=R.querySelector('.osc-promo');
    if(pr&&elPin&&pr.style.display!=='none'&&!codesOn().some(function(c){return c.toUpperCase()===code.toUpperCase()})){pr.open=true;elPin.value=code}
    var done=function(){
      btn.textContent=btn.getAttribute('data-t-copied')||'✓';
      clearTimeout(back);back=setTimeout(function(){btn.innerHTML=keep},1600);
    };
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(code).then(done,function(){legacy(code);done()})}
    else{legacy(code);done()}
  });
  function legacy(t){try{var a=document.createElement('textarea');a.value=t;a.setAttribute('readonly','');a.style.cssText='position:fixed;opacity:0';document.body.appendChild(a);a.select();document.execCommand('copy');a.remove()}catch(e){}}
})();

window.upcartRefreshCart=function(){pull()};
window.oskyCart={open:openCart,close:hide,refresh:pull};
autoU();
pull();
})();